import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=7d8b057c&scoped=true&"
import script from "./dictionary.vue?vue&type=script&lang=js&"
export * from "./dictionary.vue?vue&type=script&lang=js&"
import style0 from "./dictionary.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./dictionary.vue?vue&type=style&index=1&id=7d8b057c&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8b057c",
  null
  
)

export default component.exports